/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(11265);module.exports = "../../app/cells/components/banner/signup_banner/show.erb";

/***/ }),

/***/ 40158:
/***/ ((module) => {

module.exports = "../../app/cells/components/banner/signup_banner_cell.rb";

/***/ }),

/***/ 81296:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(37159);module.exports = "../../app/cells/components/how_study_for_contests/show.erb";

/***/ }),

/***/ 56924:
/***/ ((module) => {

module.exports = "../../app/cells/components/how_study_for_contests_cell.rb";

/***/ }),

/***/ 69559:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(45384);module.exports = "../../app/cells/components/vertical_notice/show.erb";

/***/ }),

/***/ 48461:
/***/ ((module) => {

module.exports = "../../app/cells/components/vertical_notice_cell.rb";

/***/ }),

/***/ 32214:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(45092);module.exports = "../../app/cells/pages/bifrost/study_guide/card_info/show.erb";

/***/ }),

/***/ 34341:
/***/ ((module) => {

module.exports = "../../app/cells/pages/bifrost/study_guide/card_info_cell.rb";

/***/ }),

/***/ 68419:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(20652);module.exports = "../../app/cells/pages/bifrost/study_guide/header/show.erb";

/***/ }),

/***/ 87715:
/***/ ((module) => {

module.exports = "../../app/cells/pages/bifrost/study_guide/header_cell.rb";

/***/ }),

/***/ 56763:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(47997);module.exports = "../../app/cells/pages/bifrost/study_guide/menu_bar_float/show.erb";

/***/ }),

/***/ 88931:
/***/ ((module) => {

module.exports = "../../app/cells/pages/bifrost/study_guide/menu_bar_float_cell.rb";

/***/ }),

/***/ 40820:
/***/ ((module) => {

module.exports = "../../app/cells/pages/bifrost/study_guide/menu_bar_float/landmark.erb";

/***/ }),

/***/ 38994:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./components/banner/signup_banner/index.erb
var signup_banner = __webpack_require__(6170);
// EXTERNAL MODULE: ./components/banner/signup_banner/index.rb
var banner_signup_banner = __webpack_require__(40158);
;// CONCATENATED MODULE: ./components/banner/signup_banner/index.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


const SIGNUP_BANNER_EVENT = 'account created banner';
const SIGNUP_BANNER_EXCEPT = [
    'user',
    'iterable',
    'appcues'
];
class SignupBanner {
    init() {
        this.close.on('click', (e)=>window.jQuery(e.currentTarget).parent().hide());
        this.button.on('click', (e)=>{
            const button = window.jQuery(e.currentTarget);
            const isDataEmit = button.attr('data-emit') || false;
            const flag = button.attr('data-flag') || 'flag-default';
            const theme = button.attr('data-theme') || 'theme-default';
            const position = button.attr('data-position') || 'position-default';
            if (isDataEmit) {
                this.dispatchTrackerEvent('clicked', {
                    flag,
                    theme,
                    position
                });
            }
        });
    }
    dispatchTrackerEvent(event, params = {}) {
        const data = {
            eventName: `${SIGNUP_BANNER_EVENT} ${event}`,
            except: SIGNUP_BANNER_EXCEPT,
            data: _extends({}, params)
        };
        try {
            UserTracker.emit('event', data);
        } catch (error) {
            Rollbar.error('dispatchTrackerEvent', error);
        }
    }
    constructor(){
        this.close = window.jQuery('#js-signup-banner-close');
        this.button = window.jQuery('#js-signup-banner');
    }
}
(()=>{
    new SignupBanner().init();
})();

// EXTERNAL MODULE: ./components/how_study_for_contests/index.erb
var how_study_for_contests = __webpack_require__(81296);
// EXTERNAL MODULE: ./components/how_study_for_contests/index.rb
var components_how_study_for_contests = __webpack_require__(56924);
;// CONCATENATED MODULE: ./components/how_study_for_contests/index.js



// EXTERNAL MODULE: ./components/vertical_notice/index.erb
var vertical_notice = __webpack_require__(69559);
// EXTERNAL MODULE: ./components/vertical_notice/index.rb
var components_vertical_notice = __webpack_require__(48461);
;// CONCATENATED MODULE: ./components/vertical_notice/index.js


class VerticalNoticeComponent {
    init() {
        const topics = {};
        const chapters = {};
        const contents = {};
        const disciplines = {};
        const list = [
            {
                selector: '.discipline-list-item',
                data: disciplines,
                close: [
                    topics,
                    chapters,
                    contents
                ]
            },
            {
                selector: '.topic-list-item',
                data: topics,
                close: [
                    chapters,
                    contents
                ]
            },
            {
                selector: '.chapter-list-item',
                data: chapters,
                close: [
                    contents
                ]
            },
            {
                selector: '.content-list-item',
                data: contents
            }
        ];
        list.forEach((item)=>this.watch(item));
        window.jQuery('#back-to-top').on('click', (e)=>{
            e.preventDefault();
            this.backToTop();
        });
    }
    watch({ selector, data, close }) {
        const input = 'input[type="checkbox"]';
        const list = document.querySelectorAll(`${selector} > ${input}`);
        list.forEach((item)=>{
            window.jQuery(item).on('change', (e)=>this.change(e, data, close));
        });
    }
    change(e, data, close) {
        data.current = window.jQuery(e.currentTarget);
        close.forEach((item)=>this.close(item));
        if (data.previous) {
            const currentId = data.current.prop('id');
            const previousId = data.previous.prop('id');
            if (previousId === currentId) {
                return;
            }
            data.previous.prop('checked', false);
        }
        data.previous = data.current;
    }
    close(data) {
        var _data_current, _data_previous;
        (_data_current = data.current) == null ? void 0 : _data_current.prop('checked', false);
        (_data_previous = data.previous) == null ? void 0 : _data_previous.prop('checked', false);
    }
    backToTop() {
        window.jQuery('html, body').stop().delay(100).animate({
            scrollTop: 0
        }, 500, 'swing');
    }
    constructor(){
        setTimeout(()=>this.init(), 500);
    }
}
(()=>{
    new VerticalNoticeComponent();
})();

// EXTERNAL MODULE: ./pages/bifrost/study_guide/components/card_info/index.erb
var card_info = __webpack_require__(32214);
// EXTERNAL MODULE: ./pages/bifrost/study_guide/components/card_info/index.rb
var components_card_info = __webpack_require__(34341);
;// CONCATENATED MODULE: ./pages/bifrost/study_guide/components/card_info/index.js



// EXTERNAL MODULE: ./pages/bifrost/study_guide/components/header/index.erb
var header = __webpack_require__(68419);
// EXTERNAL MODULE: ./pages/bifrost/study_guide/components/header/index.rb
var components_header = __webpack_require__(87715);
;// CONCATENATED MODULE: ./pages/bifrost/study_guide/components/header/index.js


class Header {
    init() {
        this.body = window.jQuery('html, body');
        this.button = window.jQuery('#vertical-notice-button');
        this.target = window.jQuery('#vertical-notice');
        this.button.on('click', ()=>{
            this.goToVerticalNotice();
        });
    }
    goToVerticalNotice() {
        const scrollTop = this.target.offset().top;
        this.body.stop().delay(100).animate({
            scrollTop
        }, 500, 'swing');
    }
    constructor(){
        setTimeout(()=>this.init(), 500);
    }
}
(()=>{
    new Header();
})();

// EXTERNAL MODULE: ./pages/bifrost/study_guide/components/menu_bar_float/index.erb
var menu_bar_float = __webpack_require__(56763);
// EXTERNAL MODULE: ./pages/bifrost/study_guide/components/menu_bar_float/index.rb
var components_menu_bar_float = __webpack_require__(88931);
// EXTERNAL MODULE: ./pages/bifrost/study_guide/components/menu_bar_float/landmark.erb
var landmark = __webpack_require__(40820);
// EXTERNAL MODULE: ./pages/bifrost/study_guide/components/menu_bar_float/index.module.scss
var index_module = __webpack_require__(47997);
;// CONCATENATED MODULE: ./pages/bifrost/study_guide/components/menu_bar_float/index.js




(function() {
    document.addEventListener('DOMContentLoaded', ()=>{
        const options = {
            rootMargin: '100px',
            threshold: 0
        };
        const callback = (entries)=>{
            const floatingMenu = document.querySelector('#js-floating-sidebar[data-mobile="false"]');
            entries.forEach((entry)=>{
                floatingMenu.classList.toggle(index_module["default"]["absolute-position"], entry.isIntersecting);
            });
        };
        const sidebar = window.jQuery('#js-floating-sidebar');
        const floating = sidebar.attr('data-floating');
        const isFloating = floating === 'true';
        if (isFloating) {
            const observer = new IntersectionObserver(callback, options);
            const footer = document.querySelector('#js-footer');
            observer.observe(footer);
        }
    });
})();

// EXTERNAL MODULE: ./pages/bifrost/study_guide/index.scss
var study_guide = __webpack_require__(48810);
;// CONCATENATED MODULE: ./pages/bifrost/study_guide/index.js








;// CONCATENATED MODULE: ./packs/bifrost/study_guide.js



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			2400: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [165], () => (__webpack_require__(38994)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;